import { render, staticRenderFns } from "./table3.vue?vue&type=template&id=f85b6b50&scoped=true"
import script from "./table3.vue?vue&type=script&lang=js"
export * from "./table3.vue?vue&type=script&lang=js"
import style0 from "./table3.vue?vue&type=style&index=0&id=f85b6b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85b6b50",
  null
  
)

export default component.exports